import { destructUUID } from '@tovia/man-app-utils/lib/helpers/uuids';

export const logoUrl = (cdnUrl: string, site: { networkUUID: string; abbreviation: string }, inverted = false) => {
  const logoPath = inverted ? 'inverted' : '';

  return [cdnUrl, 'logos', destructUUID(site.networkUUID), logoPath, `${site.abbreviation}.svg`]
    .filter(Boolean)
    .join('/');
};
